import { ChartBinSize, ChartDefinition, ChartKey, ChartQueryParam, ChartRendererType } from '@frontend/chart/types';

import { IOTS_VOLUME_CHART_ENDPOINT } from '../iot-chart-endpoints';

export const IOTS_VOLUME_BY_STATUS_BAR_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.IOTS_VOLUME_BY_STATUS_BAR,
    chartType: ChartRendererType.BAR,
    endpoint: IOTS_VOLUME_CHART_ENDPOINT,
    filters: [{ key: ChartQueryParam.BIN_SIZE, value: ChartBinSize.DAY }],
    groupBy: ChartQueryParam.STATUS
};
